import toast from "react-hot-toast";
import axiosInstance from "../../axiosInstance";
import { secureStorage } from "../../utils/secureStorage";
const adminToken = secureStorage.getItem("adminToken");

export const addOffer = (FormData, setFormData, navigate) => {
  axiosInstance
    .post("/offer/add", FormData, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      if (res.data.message === "Offer added successfully") {
        toast.success("offer added");
        setFormData({
          offerTitle: "",
          shortDescription: "",
          description: "",
          couponId: "",
          category: "",
          termsAndConditions: "",
          featuredImage: "",
          coverImage: "",
          isFeatured: 0,
          status: 0,
          reatedAt: "",
          createdBy: "",
        });
        navigate("/admin/offers");
      } else {
        toast.error("something went Wrong");
      }
    })
    .catch((err) => {
      toast.error("something went Wrong");
    });
};
export const offerList = (setOfferData, setPaginationData, Page, Limit) => {
  axiosInstance
    .get(`/offer/get?page=${Page}&limit=${Limit}`, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      setOfferData(res.data.data);
      setPaginationData(res.data.totalPages);
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};

export const getOffer = (id, setFormData, setContent, setDescription) => {
  axiosInstance
    .get(`/offer/get/${id}`, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      setFormData({
        id: res.data.data.id,
        offerTitle: res.data.data.offerTitle,
        shortDescription: res.data.data.shortDescription,
        description: res.data.data.description,
        couponId: res.data.data.couponId,
        category: res.data.data.category,
        termsAndConditions: res.data.data.termsAndConditions,
        featuredImage: res.data.data.featuredImage,
        coverImage: res.data.data.coverImage,
        isFeatured: res.data.data.isFeatured,
        status: res.data.data.status,
        createdAt: res.data.data.createdAt,
        createdBy: res.data.data.createdBy,
      });
      setContent(res.data.data.termsAndConditions);
      setDescription(res.data.data.description);
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};
export const updateOffer = (FormData, setFormData, navigate) => {
  axiosInstance
    .put("/offer/update", FormData, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      if (res.data.message === "Offer updated successfully") {
        toast.success("offer updated");
        setFormData({
          offerTitle: "",
          shortDescription: "",
          description: "",
          couponId: "",
          category: "",
          termsAndConditions: "",
          featuredImage: "",
          coverImage: "",
          isFeatured: 0,
          status: 0,
          reatedAt: "",
          createdBy: "",
        });
        navigate("/admin/offers");
      } else {
        toast.error("something went Wrong");
      }
    })
    .catch((err) => {
      toast.error("something went Wrong");
    });
};

export const deleterOffer = (
  setOfferData,
  setPaginationData,
  Page,
  Limit,
  id
) => {
  axiosInstance
    .delete(
      "/offer/delete",
      {
        data: { id: id },
      },
      {
        headers: {
          Authorization: `Bearer ${adminToken}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then((res) => {
      if (res.data.message === "Offer deleted successfully") {
        toast.success("Offer deleted");
        offerList(setOfferData, setPaginationData, Page, Limit);
      }
    })
    .catch((err) => {
      toast.error("something went Wrong");
    });
};
